export default "__VITE_ASSET__DJ2F5XqN__"